<template>
    <svg :class="design" :width="width" :height="height" viewBox="0 0 8 1" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.35417 0C1.82467 0 6.17533 0 0.645833 0C0.565625 0 0.5 0.0656249 0.5 0.145833V0.729167C0.5 0.809375 0.565625 0.875 0.645833 0.875C6.17533 0.875 1.82467 0.875 7.35417 0.875C7.43438 0.875 7.5 0.809375 7.5 0.729167V0.145833C7.5 0.0656249 7.43438 0 7.35417 0Z"
            :fill="fill" />
    </svg>
</template>
<script>
export default {
    name: 'ui-minus-icon',
    props: {
        design: {
            type: String,
            default: ''
        },
        fill: {
            type: String,
            default: '#A4A4CA'
        },
        width: {
            type: [String, Number],
            default: 8
        },
        height: {
            type: [String, Number],
            default: 1
        }
    }
}
</script>